<div class="even">
    <mat-label class="subHeading">CPA Cover<span *ngIf="isRequired" class="star">*</span></mat-label>
    <button class="side" (click)="form.controls['cpa'].setValue(null)">Remove</button>
</div>
<mat-select formControlName="cpa" class="cpa" placeholder="Select">
    <mat-option [value]="true">True</mat-option>
    <mat-option [value]="false">False</mat-option>
</mat-select>